module.exports = __webpack_public_path__ + "img/banner.1a7d054a.png";